var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../../../elements/Basic");

var _index = _interopRequireDefault(require("../../../../../i18n/index"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/DataFetching/NoData/index.js";

var NoDataComponent = function NoDataComponent(_ref) {
  var messageKey = _ref.messageKey,
      messageValue = _ref.messageValue,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["messageKey", "messageValue", "size"]);
  return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
    center: true,
    height: 100
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.Text, {
    bold: true,
    size: size,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 9
    }
  }, messageValue || (0, _index.default)(messageKey || 'fetching_data_empty')));
};

var _default = NoDataComponent;
exports.default = _default;